'use strict';

var Location_v1alpha1_schema = require('../schema/kinds/Location.v1alpha1.schema.json.cjs.js');
var util = require('./util.cjs.js');

const locationEntityV1alpha1Validator = util.ajvCompiledJsonSchemaValidator(Location_v1alpha1_schema.default);

exports.locationEntityV1alpha1Validator = locationEntityV1alpha1Validator;
//# sourceMappingURL=LocationEntityV1alpha1.cjs.js.map
